module.exports = __webpack_public_path__ + "img/upload.dd1e2c4c.png";